module.exports = __webpack_public_path__ + "static/media/playlist.4bbb571d.jpg";